module.exports = __webpack_public_path__ + "img/battery_2disable.b5360ba2.png";